import { useState } from 'react';
import JxButton from '../../../JxControls/JxButtons/JxButton';
import { JxSelect } from '@/JxControls';
import SeqDiaOutputPanel from './SeqDiaOutputPanel';
import { Box } from '@mui/material';

/**
 * Sequence-diagram mode controls — parse dropped files, pick entry class/method,
 * generate mermaid sequence source. Owns its own entry-point selection state
 * (mode-local, resets naturally when unmounted on mode switch).
 * @param {{ seqDia: object, droppedFilesLength: number, onClearFiles: () => void }} props
 * @returns {JSX.Element}
 */
export default function SeqDiaImportPanel({ seqDia, droppedFilesLength, onClearFiles }) {
    const [selectedEntryClass, setSelectedEntryClass] = useState('');
    const [selectedEntryMethod, setSelectedEntryMethod] = useState('');

    const methodOptionsForClass = seqDia.entryPointOptions.filter(function sameClass(o) {
        return o.className === selectedEntryClass;
    });

    const handleEntryClassChange = (v) => {
        setSelectedEntryClass(v);
        setSelectedEntryMethod('');
    };

    return (
        <div className="usd-seqdia-controls">
            <div className="usd-button-row">
                <JxButton
                    className="jx-button-sm"
                    label="Parse files"
                    onClick={seqDia.parseFiles}
                    disabled={droppedFilesLength === 0 || seqDia.isParsing}
                />
                <JxButton className="jx-button-sm" label="Clear Files" onClick={onClearFiles} disabled={droppedFilesLength === 0} />
            </div>

            {seqDia.parseWarnings.length > 0 && (
                <div className="usd-import-text">Parse warnings: {seqDia.parseWarnings.join('; ')}</div>
            )}

            {seqDia.entryPointOptions.length > 0 && (
                <Box>
                    <div className="usd-button-row">
                        <JxSelect
                            id="usd-seqdia-entry-class-select"
                            value={selectedEntryClass}
                            onChange={handleEntryClassChange}
                            options={Array.from(new Set(seqDia.entryPointOptions.map((o) => o.className))).map((c) => ({
                                label: c,
                                value: c,
                            }))}
                            defaultLabel="Entry class..."
                        />
                    </div>
                    <div className="usd-button-row">
                        <JxSelect
                            id="usd-seqdia-entry-method-select"
                            value={selectedEntryMethod}
                            onChange={setSelectedEntryMethod}
                            options={methodOptionsForClass.map((o) => ({ label: o.methodName, value: o.methodName }))}
                            disabled={!selectedEntryClass}
                            defaultLabel="Entry method..."
                        />
                    </div>

                    <div className="usd-button-row">
                        <JxButton
                            className="jx-button-sm"
                            label="Generate sequence"
                            onClick={() => seqDia.generate(selectedEntryClass, selectedEntryMethod)}
                            disabled={!selectedEntryClass || !selectedEntryMethod}
                        />
                    </div>

                    <div className="usd-button-row"></div>
                </Box>
            )}

            <SeqDiaOutputPanel mermaidSource={seqDia.mermaidSource} warnings={seqDia.generateWarnings} />
        </div>
    );
}
